import DepartmentActionTypes from "./department.types";

/** ***************** ADD DEPARATMENT DETAILS START *********************** */
export const addDepartmentDetailsStart = (addData: any) => ({
  type: DepartmentActionTypes.ADD_DEPARTMENT_DETAILS_START,
  payload: addData,
});

export const addDepartmentDetailsSuccess = (successData: any) => ({
  type: DepartmentActionTypes.ADD_DEPARTMENT_DETAILS_SUCCESS,
  payload: successData,
});

export const addDepartmentDetailsFailure = (failureData: any) => ({
  type: DepartmentActionTypes.ADD_DEPARTMENT_DETAILS_FAILURE,
  payload: failureData,
});

export const addDepartmentDetailsResponseResetStart = () => ({
  type: DepartmentActionTypes.ADD_DEPARTMENT_DETAILS_RESPONSE_RESET,
});

export const addDepartmentDetailsResponseChanged = () => ({
  type: DepartmentActionTypes.ADD_DEPARTMENT_DETAILS_RESPONSE_CHANGED,
});
/** ***************** ADD DEPARATMENT DETAILS END *********************** */

/** ***************** UPDATE DEPARATMENT DETAILS START *********************** */
export const updateDepartmentDetailsStart = (updateData: any) => ({
  type: DepartmentActionTypes.UPDATE_DEPARTMENT_DETAILS_START,
  payload: updateData,
});

export const updateDepartmentDetailsSuccess = (successData: any) => ({
  type: DepartmentActionTypes.UPDATE_DEPARTMENT_DETAILS_SUCCESS,
  payload: successData,
});

export const updateDepartmentDetailsFailure = (failureData: any) => ({
  type: DepartmentActionTypes.UPDATE_DEPARTMENT_DETAILS_FAILURE,
  payload: failureData,
});

export const updateDepartmentDetailsResponseResetStart = () => ({
  type: DepartmentActionTypes.UPDATE_DEPARTMENT_DETAILS_RESPONSE_RESET,
});

export const updateDepartmentDetailsResponseChanged = () => ({
  type: DepartmentActionTypes.UPDATE_DEPARTMENT_DETAILS_RESPONSE_CHANGED,
});
/** ***************** UPDATE DEPARATMENT DETAILS END *********************** */

/** ***************** GET DEPARATMENT DETAILS START *********************** */
export const getDepartmentListStart = (getData: any) => ({
  type: DepartmentActionTypes.GET_DEPARTMENT_LIST_START,
  payload: getData,
});

export const getDepartmentListSuccess = (successData: any) => ({
  type: DepartmentActionTypes.GET_DEPARTMENT_LIST_SUCCESS,
  payload: successData,
});

export const getDepartmentListFailure = (failureData: any) => ({
  type: DepartmentActionTypes.GET_DEPARTMENT_LIST_FAILURE,
  payload: failureData,
});

export const getDepartmentListResponseResetStart = () => ({
  type: DepartmentActionTypes.GET_DEPARTMENT_LIST_RESPONSE_RESET,
});

export const getDepartmentListResponseChanged = () => ({
  type: DepartmentActionTypes.GET_DEPARTMENT_LIST_RESPONSE_CHANGED,
});
/** ***************** GET DEPARATMENT DETAILS END *********************** */

/** ***************** FETCH DEPARATMENT DETAILS START *********************** */
export const fetchDepartmentDetailsStart = (fetchData: any) => ({
  type: DepartmentActionTypes.FETCH_DEPARTMENT_DETAILS_START,
  payload: fetchData,
});

export const fetchDepartmentDetailsSuccess = (successData: any) => ({
  type: DepartmentActionTypes.FETCH_DEPARTMENT_DETAILS_SUCCESS,
  payload: successData,
});

export const fetchDepartmentDetailsFailure = (failureData: any) => ({
  type: DepartmentActionTypes.FETCH_DEPARTMENT_DETAILS_FAILURE,
  payload: failureData,
});

export const fetchDepartmentDetailsResponseResetStart = () => ({
  type: DepartmentActionTypes.FETCH_DEPARTMENT_DETAILS_RESPONSE_RESET,
});

export const fetchDepartmentDetailsResponseChanged = () => ({
  type: DepartmentActionTypes.FETCH_DEPARTMENT_DETAILS_RESPONSE_CHANGED,
});
/** ***************** FETCH DEPARATMENT DETAILS END *********************** */

/** ***************** DELETE DEPARATMENT DETAILS START *********************** */
export const deleteDepartmentDetailsStart = (deleteData: any) => ({
  type: DepartmentActionTypes.DELETE_DEPARTMENT_DETAILS_START,
  payload: deleteData,
});

export const deleteDepartmentDetailsSuccess = (successData: any) => ({
  type: DepartmentActionTypes.DELETE_DEPARTMENT_DETAILS_SUCCESS,
  payload: successData,
});

export const deleteDepartmentDetailsFailure = (failureData: any) => ({
  type: DepartmentActionTypes.DELETE_DEPARTMENT_DETAILS_FAILURE,
  payload: failureData,
});

export const deleteDepartmentDetailsResponseResetStart = () => ({
  type: DepartmentActionTypes.DELETE_DEPARTMENT_DETAILS_RESPONSE_RESET,
});

export const deleteDepartmentDetailsResponseChanged = () => ({
  type: DepartmentActionTypes.DELETE_DEPARTMENT_DETAILS_RESPONSE_CHANGED,
});
/** ***************** DELETE DEPARATMENT DETAILS END *********************** */
